export default class DogMemberClubFee {
    static fromData(data) {
        if (!data) {
            return;
        }

        const dogMemberClubFee = new DogMemberClubFee();
        dogMemberClubFee.id = data.id;
        dogMemberClubFee.memberClubFee = data.memberClubFee;
        dogMemberClubFee.dog = data.dog;

        Object.seal(dogMemberClubFee);
        return dogMemberClubFee;
    }
}
